import { Center } from '@chakra-ui/react';

interface PendingCountBadgeProps {
    count: number;
}

/**
 * Count badge matching the Dashboard Rejected-tab pill treatment.
 * Hidden when count is 0.
 */
export function PendingCountBadge({ count }: PendingCountBadgeProps) {
    if (count <= 0) return null;

    return (
        <Center
            position="absolute"
            top="-6px"
            right="-6px"
            bg="red.500"
            color="white"
            borderRadius="full"
            fontSize="10px"
            fontWeight="bold"
            minW="18px"
            h="18px"
            px={1}
            zIndex={1}
            pointerEvents="none"
        >
            {count > 99 ? '99+' : count}
        </Center>
    );
}

export default PendingCountBadge;
